import './../../index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const ItAccreditationSize16Component = (props, ref) => (jsxs("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M11.8115 14.6667V8.05799H13.6666V5.97104H11.8115V2.49276H9.72456L9.72456 5.97104H7.86949V8.05799H9.72456L9.72456 14.6667H11.8115Z", fill: "var(--magritte-ui-icon-color)" }), jsx("path", { d: "M6.27527 5.97101H2.33325V8.05797H4.18832V14.6666H6.27527V5.97101Z", fill: "var(--magritte-ui-icon-color)" }), jsx("path", { d: "M5.23177 4.23189C6.03218 4.23189 6.68104 3.58303 6.68104 2.78262C6.68104 1.98221 6.03218 1.33334 5.23177 1.33334C4.43136 1.33334 3.7825 1.98221 3.7825 2.78262C3.7825 3.58303 4.43136 4.23189 5.23177 4.23189Z", fill: "var(--magritte-ui-icon-color)" })] }));
const ItAccreditationSize16 = hoc(forwardRef(ItAccreditationSize16Component), 'ItAccreditationSize16');

export { ItAccreditationSize16 as default };
//# sourceMappingURL=ItAccreditationSize16.js.map
